<ng-container *ngrxLet="vm$ as vm">
    @if (vm) {
        <ds-card class="results-header" [elevated]="dsComponents?.dsCardStatic?.elevated" [variant]="dsComponents?.dsCardStatic?.variant">
            <div class="results-header-content">
                <div class="results-header-title">
                    {{ vm.title }}
                </div>
                <div class="results-header-subtitle">
                    {{ vm.description }}
                </div>
            </div>
            <div class="results-header-image">
                <img [attr.src]="vm.headerImage?.src" />
            </div>
        </ds-card>
    }
</ng-container>
